import { render, staticRenderFns } from "./AsidePromotionInput.vue?vue&type=template&id=6c70ef14&scoped=true&"
import script from "./AsidePromotionInput.vue?vue&type=script&lang=js&"
export * from "./AsidePromotionInput.vue?vue&type=script&lang=js&"
import style0 from "./AsidePromotionInput.vue?vue&type=style&index=0&id=6c70ef14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c70ef14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
